export default "__VITE_ASSET__BbFtrYko__"